import { render, staticRenderFns } from "./analisi.vue?vue&type=template&id=4a907fce&"
import script from "./analisi.vue?vue&type=script&lang=js&"
export * from "./analisi.vue?vue&type=script&lang=js&"
import style0 from "./analisi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports